module.exports = __webpack_public_path__ + "img/2026-02-27b_1.f9914503.jpg";